import { render, staticRenderFns } from "./ProfileAnswers.vue?vue&type=template&id=3dad6f7c&"
import script from "./ProfileAnswers.vue?vue&type=script&lang=js&"
export * from "./ProfileAnswers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports